import axios from 'axios'
import Vue from 'vue'

export async function fetchPermisosUsuarios(context, payload){
    try{
        let url = "api/getpermisosusuario"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('id',payload)    
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })

        context.commit('setPermisoUsuario', response.data)

    }catch(error){
        context.commit('permisosError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}

export async function fetchPermisos(context, payload){
    try{
        let url = "api/getpermisos"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })

        context.commit('setPermisos', response.data)

    }catch(error){
        context.commit('permisosError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }

}

export async function create (context,payload){
    try{
        let url = "api/addpermiso"//la direccion de la api
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('rol',payload.rol)
        values.append('menu',payload.menu) 
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')    

        await Vue.axios({
            method: 'POST',
            url: url,
            data: values 
        })  
        
        context.commit('setIsOk', true);//si todo esta bien  llamamos a la mutacion y la seteamos en true.
    }catch(error){
        context.commit('permisosError',error)
    }
    finally{
        context.commit('setLoading',false,{root:true}) // finalizamos el loading
    }
   
}
/**
 *  Metodo que borra el rol de la tabla permisos.
 * @param {*} context 
 * @param {*} payload 
 */
export async function deleted (context,payload){
    try{
        let url = "api/deletepermisorol"//la direccion de la api
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('rol',payload)
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')    

        await Vue.axios({
            method: 'POST',
            url: url,
            data: values 
        })  
        
        context.commit('setIsOk', true);//si todo esta bien  llamamos a la mutacion y la seteamos en true.
    }
    catch{
        context.commit('permisosError',error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}